const epochs = [
  ["year", 31536e3],
  ["month", 2592e3],
  ["day", 86400],
  ["hour", 3600],
  ["minute", 60],
  ["second", 1]
];
const getDuration = (timeAgoInSeconds) => {
  for (const [epoch, seconds] of epochs) {
    const interval = Math.floor(timeAgoInSeconds / seconds);
    if (interval >= 1) {
      return { interval, epoch };
    }
  }
  return void 0;
};
const timeAgo = (date, translations) => {
  const dt = typeof date === "string" || typeof date === "number" ? new Date(date) : date;
  const timeAgoInSeconds = Math.floor(((/* @__PURE__ */ new Date()).getTime() - dt.getTime()) / 1e3);
  const duration = getDuration(timeAgoInSeconds);
  if ((duration == null ? void 0 : duration.interval) && duration.epoch) {
    const suffix = duration.interval === 1 ? "" : translations.plural;
    return `${duration.interval} ${translations[duration.epoch]}${suffix} ${translations.ago}`;
  }
  return translations.justNow;
};
export {
  timeAgo
};
